import React, { Fragment } from 'react';

import * as S from './styles';

export function ContentHeader({
  title = '',
  subtitle,
  icon: Icon,
  growTitle = false,
  secondComponent,
  thirdComponent,
  ...rest
}) {
  return (
    <S.Container {...rest}>
      <S.Content hasSecondComponent={!!secondComponent}>
        <S.TitleWrapper>
          {Icon && (
            <S.IconBadge>
              <Icon size={18} />
            </S.IconBadge>
          )}
          {subtitle ? (
            <S.TitleTextGroup>
              <S.Title>{title}</S.Title>
              <S.Subtitle>{subtitle}</S.Subtitle>
            </S.TitleTextGroup>
          ) : (
            <S.Title>{title}</S.Title>
          )}
        </S.TitleWrapper>

        <S.MiddleContent>{secondComponent ?? <Fragment />}</S.MiddleContent>
        <S.LastContent
          hasSecondComponent={!!secondComponent}
          hasThirdComponent={!!thirdComponent}
        >
          {thirdComponent ?? <Fragment />}
        </S.LastContent>
      </S.Content>
      <S.Divider />
    </S.Container>
  );
}
